import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CertificationTestExecutionListPendingReview from './CertificationTestExecutionListPendingReview';
import CertificationTestExecutionListService from '../services/CertificationTestExecutionListService';

class CertificationTestExecutionListPendingReviewContainer extends Component {
  certificationTestListService = new CertificationTestExecutionListService();

  componentDidMount() {
    this.certificationTestListService.init('pending_correction');
  }

  render() {
    return (
      <CertificationTestExecutionListPendingReview
        certificationTests={toJS(this.certificationTestListService.certificationTests)}
        fetching={this.certificationTestListService.fetch.fetching}
        onChange={this.certificationTestListService.handleChange}
        pagination={this.certificationTestListService.pagination}
      />
    );
  }
}

export default observer(CertificationTestExecutionListPendingReviewContainer);
